import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { FORM_KEYS } from './queryKeys';

/** `enabled` lets callers defer the fetch until it's actually needed (e.g. a closed dialog). */
export function useFormSharing(formId: string, enabled = true) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: FORM_KEYS.sharing(orgId ?? '', formId),
    queryFn: ({ signal }) => formsService.getSharing(formId, signal),
    staleTime: 60_000,
    enabled: !!orgId && !!formId && enabled,
  });

  return {
    sharing: data?.data,
    isLoading,
    isError,
  };
}
